import React, { useEffect, useState } from "react";
import { ImageContainer } from './Components';
import Header from "../../components/Header/Header";
import RegistrationForm from "./RegistrationForm/RegistrationForm";
import { useTranslation } from 'react-i18next';
import JivoButton from "../../components/JivoButton";

const RegisterSchools = ({ setAuth }) => {
  const { t } = useTranslation('registerPage');
  const [showJivoButton, setShowJivoButton] = useState(true);

  const handleHideJivoButton = () => {
    setShowJivoButton(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header
        isHome={true}
        greeting={t('HEADER_TITLE')}
        subtitle={t('HEADER_SUBTITLE')}
      />
      <RegistrationForm setAuth={setAuth} country="S1" type="open-schools" />      
      <ImageContainer
        style={{
          paddingTop:30
        }}
      >
        <img
          src="/assets/Vacina_GSK.png"
          alt="logo passe verde"
          width="200"
        />
      </ImageContainer>

      {showJivoButton && <JivoButton onClickCloseButton={handleHideJivoButton} />}
    </>
  );
};

export default RegisterSchools;